import '../sass/main.scss'
import App from './App.svelte'

const app = new App({ target: document.getElementById('lms-logo') })

export default app
